"use client";

import Section from "./section";
import { Particles } from "../magicui/particles";
import { motion } from "motion/react";

export default function ConstructionTechnologySection() {
  return (
    <Section>
      <div className="relative rounded-3xl overflow-hidden">
        <div className="absolute inset-0 bg-card" aria-hidden="true" />
        <div className="relative z-10 flex flex-col items-center justify-center gap-8 py-24 px-6 md:px-12">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium tracking-wide uppercase">
              <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse" />
              Innovation
            </span>
          </motion.div>

          {/* Title */}
          <div className="space-y-4 flex flex-col items-center">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl text-center"
            >
              Smarter On-Site Technology
            </motion.h2>
            <motion.div
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="h-1 w-20 bg-linear-to-r from-primary to-secondary rounded-full"
            />
          </div>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-lg md:text-xl text-muted-foreground max-w-2xl text-center leading-relaxed"
          >
            Construction technology refers to the collection of innovative tools, machinery and equipment used during the construction phase of a project that enables advancement in field construction methods.
          </motion.p>
        </div>
        <Particles
          className="absolute inset-0 z-[-1]"
          quantity={100}
          ease={80}
          color="#aaa39b"
          refresh
        />
      </div>
    </Section>
  )
} 
